// constants/relationships.js — Anamoria SPA
// v1.0 — Consent PR E1 (Oct 4, 2026): the ONE shared relationship list for owners (Create a Space,
//   Settings) and contributors (invite form, E2). Copy v0.3 §5.1 — FINAL, approved by Sophie 2026-10-03:
//   today's 11 plus aunt or uncle, cousin, niece or nephew. Codes are the stable values the server
//   accepts (anamoria-spaces / anamoria-contributors RELATIONSHIP_CODES, 14, CI drift-guarded);
//   labels are the approved wording. Order: close family, extended family, friend, "Someone else…".
//   Expand-only: existing codes never change (plan v0.26 D23).
export const RELATIONSHIP_OPTIONS = [
  ['spouse_or_partner', 'My spouse or partner'],
  ['mother', 'My mother'],
  ['father', 'My father'],
  ['son', 'My son'],
  ['daughter', 'My daughter'],
  ['brother', 'My brother'],
  ['sister', 'My sister'],
  ['grandparent', 'My grandparent'],
  ['grandchild', 'My grandchild'],
  ['aunt_or_uncle', 'My aunt or uncle'],
  ['cousin', 'My cousin'],
  ['niece_or_nephew', 'My niece or nephew'],
  ['friend', 'My friend'],
  ['other', 'Someone else…'],
];

export const RELATIONSHIP_CODES = RELATIONSHIP_OPTIONS.map(([code]) => code);
